"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TITLE = exports.MOBILE_FILTERS = exports.MOBILE_FILTERS_CONTAINER = exports.RESET_BUTTON = exports.MODAL_BUTTONS = exports.DROPDOWN_CLS_MOBILE = exports.OPEN_ANIMATION_DURATION_MS = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../../../common/styles/vars"),
    OPEN_ANIMATION_DURATION_MS = 300;

exports.OPEN_ANIMATION_DURATION_MS = OPEN_ANIMATION_DURATION_MS;
var DROPDOWN_CLS_MOBILE = (0, _cxs["default"])({
  width: "100%"
});
exports.DROPDOWN_CLS_MOBILE = DROPDOWN_CLS_MOBILE;
var MODAL_BUTTONS = (0, _cxs["default"])({
  marginTop: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  " > .button:first-of-type": {
    marginRight: "10px"
  }
});
exports.MODAL_BUTTONS = MODAL_BUTTONS;
var RESET_BUTTON = (0, _cxs["default"])({
  color: _vars.COLOURS.grey.regent,
  marginLeft: "12px"
});
exports.RESET_BUTTON = RESET_BUTTON;

var MOBILE_FILTERS_CONTAINER = function MOBILE_FILTERS_CONTAINER(a, b) {
  return (0, _cxs["default"])({
    maxHeight: a ? "1000px" : 0,
    transition: "max-height .".concat(OPEN_ANIMATION_DURATION_MS / 100, "s ease-in-out"),
    overflow: a && !b ? "visible" : "hidden",
    " > hr": {
      height: "1px",
      backgroundColor: _vars.COLOURS.grey.mischka.russian,
      border: "none"
    }
  });
};

exports.MOBILE_FILTERS_CONTAINER = MOBILE_FILTERS_CONTAINER;
var MOBILE_FILTERS = (0, _cxs["default"])({
  height: "auto",
  padding: "10px 0 20px 0",
  boxSizing: "border-box",
  width: "100%",
  "> div:not(:last-child)": {
    marginBottom: "25px",
    borderRadius: "6px!important",
    border: "1px transparent!important"
  }
});
exports.MOBILE_FILTERS = MOBILE_FILTERS;
var TITLE = (0, _cxs["default"])({
  fontSize: _vars.FONT_SIZES.large,
  fontWeight: _vars.FONT_WEIGHTS.regular,
  letterSpacing: "2px",
  marginTop: "15px"
});
exports.TITLE = TITLE;